<!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2022/04/03
    // Modificado por: 
    // Fecha de ultima Modificacion:    
    // Causa: 

    ///////////////////////////////////////////////////////////
-->
<template>
    <div>
        <!-- Incidencia Conductual -->
        <!-- SNACKBAR DE MODIFICACION ALERTAS -->



        <v-form ref="formDatos" lazy-validation>
            <ComunDialogComp v-model="estadoModal" maxWidth="1200" :title="formTitle"
                @close-modal="removeImg(); $emit('close')">
                <template v-slot:body>

                    <v-row>
                        <v-col cols="12" class="d-flex align-center" v-show="parametros.evento != 'add'">
                            <span>Año Lectivo: </span>
                            <span>{{ datos.ano_lectivo }}</span>
                            <v-spacer></v-spacer>
                            <v-chip label color="green" dark>
                                Nivel: {{ datos.desc_nivel }} | Grado: {{ datos.desc_grado }} | Seccion: {{
                                    datos.nombre_seccion }}
                            </v-chip>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="3" lg="2">
                                            <p>Registro a nombre de:</p>
                                            <v-radio-group row v-model="datos.registro_tipo" class="mt-0"
                                                @change="eventRegistroTipo(datos.registro_tipo)"
                                                :disabled="disableModalFilters">
                                                <v-radio :label="`Estudiante`" :value="1" color="teal"></v-radio>
                                                <v-radio :label="`Sección`" :value="2" color="error"></v-radio>
                                            </v-radio-group>
                                        </v-col>

                                        <v-col v-if="datos.registro_tipo == 1">

                                            <v-row class="pt-1">
                                                <v-col cols="12" md="4" lg="3">
                                                    <textfieldComp textLabel="Documento de identidad" type="text"
                                                        v-model="datos.num_documento" :disabled="disableModalFilters"
                                                        :rules="validationRules.validateCampo" />
                                                </v-col>

                                                <v-col cols="12" md="3" lg="2" class="d-flex align-center">
                                                    <TableButtonComp normalButton @click="eventSearch(datos.num_documento)"
                                                        :disabled="disableModalFilters" textButton="Buscar"
                                                        iconBut="fas fa-search" />
                                                </v-col>

                                                <v-col cols="12" md="4" lg="3">
                                                    <textfieldComp textLabel="Estudiante" type="text" v-model="datos.alumno"
                                                        readonly :rules="validationRules.validateCampo"
                                                        :disabled="disableModalFilters" />
                                                </v-col>

                                                <v-col cols="12" md="4" lg="3">
                                                    <AutocompleteComp textLabel="Periodo" v-model="datos.id_periodo"
                                                        @change="selectPeriodo($event)" :items="listPeriodo"
                                                        item-text="nombre_periodo" item-value="id"
                                                        :rules="validationRules.validateCampo"
                                                        :isDisable="disableModalFilters" />
                                                </v-col>

                                            </v-row>
                                        </v-col>

                                        <v-col v-if="datos.registro_tipo == 2">

                                            <v-row>
                                                <v-col cols="12" sm="4" md="">
                                                    <AutocompleteComp textLabel="Nivel" v-model="datos.id_nivel"
                                                        @change="eventNivel(datos.id_nivel)" :items="listNivel"
                                                        item-text="desc_nivel" item-value="id"
                                                        :isDisable="disableModalFilters" />
                                                </v-col>


                                                <v-col cols="12" sm="4" md="">
                                                    <AutocompleteComp textLabel="Grado" v-model="datos.id_grado"
                                                        @change="eventGrado(datos.id_grado)" :items="listGrado"
                                                        item-text="desc_grado" item-value="id"
                                                        :isDisable="disableModalFilters" />
                                                </v-col>

                                                <v-col cols="12" sm="4" md="">
                                                    <AutocompleteComp textLabel="Sección" v-model="datos.id_seccion"
                                                        @change="eventSeccion(datos.id_seccion)" :items="listSeccion"
                                                        item-text="nombre_seccion" item-value="id"
                                                        :isDisable="disableModalFilters"
                                                        :rules="validationRules.validateCampo" />

                                                </v-col>

                                                <v-col cols="12" sm="4" md="">
                                                    <AutocompleteComp textLabel="Estudiante" v-model="datos.id_alumno"
                                                        :items="listAlumno" item-text="nombre_apellido" item-value="id"
                                                        @change="eventAlumno(datos.id_alumno)"
                                                        :isDisable="disableModalFilters"
                                                        :rules="validationRules.validateCampo" />

                                                </v-col>

                                                <v-col cols="12" sm="4" md="">
                                                    <AutocompleteComp textLabel="Periodo" v-model="datos.id_periodo"
                                                        @change="selectPeriodo($event)" :isDisable="disableModalFilters"
                                                        :items="listPeriodo" item-text="nombre_periodo" item-value="id"
                                                        :rules="validationRules.validateCampo" />
                                                </v-col>

                                            </v-row>
                                        </v-col>


                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <v-menu v-model="menu2" :close-on-content-click="false"
                                                transition="scale-transition" offset-y max-width="290px" min-width="290px"
                                                :disabled="disableForm">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-model="computedDateFormatted2" label="Fecha" readonly
                                                        v-on="on" :rules="validationRules.validateCampo"
                                                        :disabled="disableForm">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker :allowed-dates="allowedDays" v-model="datos.fecha" no-title
                                                    @input="menu2 = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>

                                        <v-col cols="6" md="3">
                                            <v-text-field v-model="datos.hora" label="Hora de inicio"
                                                :disabled="disableForm" type="time" min="00:01" max="23:59" step="600"
                                                :rules="validationRules.validateCampo"></v-text-field>
                                        </v-col>

                                        <!-- Merito o Desmetito -->

                                        <v-col cols="12" md="3">
                                            <p>Tipo Incidencia</p>
                                            <v-radio-group row v-model="datos.id_tipo_incidencia"
                                                @change="eventTipoIncidencia(datos.id_tipo_incidencia)" class="mt-0">
                                                <v-radio v-for="item of listTipoIncidencia" :key="item.id"
                                                    :label="item.descripcion" :value="item.id" :disabled="disableForm">
                                                </v-radio>
                                            </v-radio-group>
                                        </v-col>

                                        <v-col cols="12" md="3" class="d-flex align-center">
                                            <v-text-field label="Nº de incidencia" type="text" v-model="datos.id_incidencia"
                                                v-on:keyup.enter="findIncidencia(datos.id_incidencia)"
                                                :disabled="disableForm">
                                            </v-text-field>
                                            <TableButtonComp @click="eventIncidencia()" iconBut="fas fa-list"
                                                :disabled="disableForm" tooltip-text="Seleccionar incidencias"
                                                class-color="primary" />
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <textfieldComp textLabel="Nivel de la incidencia"
                                                v-model="datos.nivel_incidencia" readonly :disabled="disableForm" />
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <textfieldComp textLabel="Descripción de la incidencia"
                                                v-model="datos.incidencia" readonly :disabled="disableForm" />
                                        </v-col>

                                        <v-col cols="12" md="4" lg="4">
                                            <AutocompleteComp textLabel="Tipo de papeleta" v-model="datos.id_papeleta"
                                                :items="listPapeleta" item-value="id" item-text="tipo_papeleta"
                                                :rules="validationRules.validateCampoList"
                                                @change="eventPapeleta(datos.id_papeleta)" :isDisable="disableForm" />
                                        </v-col>

                                        <v-col cols="12" md="2" lg="2">
                                            <textfieldComp textLabel="Puntaje" v-model="datos.puntaje" readonly
                                                :disabled="disableForm" />
                                        </v-col>

                                        <v-col cols="12" md="6" lg="3">
                                            <AutocompleteComp textLabel="Perfil del solicitante" v-model="datos.id_perfil"
                                                :items="listUsuarioPerfil" item-value="id" item-text="descripcion_perfil"
                                                :rules="validationRules.validateCampoList"
                                                @change="eventPerfil(datos.id_perfil)" :isDisable="disableForm" />

                                        </v-col>

                                        <v-col cols="12" md="6" lg="3">
                                            <AutocompleteComp textLabel="Nombre" v-model="datos.id_solicitante"
                                                :items="listUsuario" item-value="id" item-text="apellido_nombre"
                                                :rules="validationRules.validateCampoList" :isDisable="disableForm" />
                                        </v-col>

                                        <v-col cols="6">
                                            <textfieldComp textArea v-model="datos.observacion"
                                                textregistro_tipoLabel="Observación" rows="1" :disabled="disableForm" />
                                        </v-col>

                                        <v-col cols="11" md="6" v-if="parametros.evento != 'view'">
                                            <!-- <h2>Subir archivo</h2>  
        <input type="file" name="subirArchivo" ref="fileImageSave" @change="onFileChange" accept=".jpg,.png,.gif"> -->
                                            <v-file-input label="Subir archivo" accept=".docx, .pdf, .doc"
                                                v-model="archivoSubir">
                                            </v-file-input>
                                        </v-col>


                                        <v-col cols="11" md="6" v-else>
                                            <!-- <TableButtonComp :disabled="datos.img_nombre" v-if="datos.img_nombre"
                                                text-button="Ver imagen adjuntada" icon-but="fa-file-download"
                                                @click="download(URL_SPACE + '/' + datos.img_ruta)" /> -->
                                            <TableButtonComp v-if="datos.img_nombre"
                                                @click="download(URL_SPACE + '/' + datos.img_ruta)"
                                                iconBut="fa-file-download" textButton="Ver archivo adjunto" />
                                            <TableButtonComp v-else iconBut="fa-file-download" disabled
                                                textButton="Ver archivo adjunto" />

                                        </v-col>

                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>

                    </v-row>

                </template>
                <template v-slot:actions>
                    <v-spacer />
                    <TableButtonComp normalButton v-if="parametros.evento == 'edit'"
                        @click="saveItem(URL_SPACE); removeImg()" :disabled="inhabilitarButton" textButton="Guardar cambios"
                        iconBut="fas fa-save" />
                    <TableButtonComp normalButton v-if="parametros.evento == 'add'"
                        @click="submitForm(URL_SPACE); removeImg()" :disabled="inhabilitarButton" textButton="Guardar"
                        iconBut="fas fa-save" />
                    <TableButtonComp normalButton @click="removeImg(); $emit('close')" classButton="ml-2"
                        textButton="Cancelar" classColor="red" />
                </template>
            </ComunDialogComp>


        </v-form>

        <!-- fin modal incidencia Conductual -->


        <!-- Start Dialogo de Incidencia   -->

        <ComunDialogComp v-model="dialogIncidencia" max-width="700" :title="formTitle2"
            @close-modal="dialogIncidencia = false">
            <template v-slot:body>
                <ComundataTablecomp whitSearch :headers="SelectorIncidenciaHeaders" :items="listIncidencia"
                    :search="search">
                    <template v-slot:action_select="{ item }">
                        <v-radio-group row v-model="datos.id_incidencia" @change="addIncidencia(item)">
                            <v-radio :value="item.id" color="teal"></v-radio>
                        </v-radio-group>
                    </template>
                </ComundataTablecomp>
            </template>
            <template v-slot:actions>
                <v-spacer />
                <TableButtonComp @click="dialogIncidencia = false" textButton="Agregar" iconBut="fas fa-plus"
                    normalButton />
            </template>
        </ComunDialogComp>


        <!-- END dialogo de  Incidencia -->


    </div>
</template>

<script>

import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios"
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { SelectorIncidenciaHeaders } from '../../../../helpers/headersTable';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import textfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import TableButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import { validationRules } from '../../../../helpers/validatorHelpers';

export default {
    components: {
        ComunDialogComp,
        textfieldComp,
        AutocompleteComp,
        TableButtonComp,
        ComundataTablecomp

    },
    name: 'modalIncidenciaFormulario',
    props: {
        parametros: {
            type: Object
        },
        estadoModal: {
            type: Boolean
        },
    },
    data: vm => ({
        SelectorIncidenciaHeaders,
        datoLogin: sessionStorage,
        evento: null,
        test: false,
        datos: {},
        paramComponente: { 'id_submodulo': 22, "id_modulo": 4 },
        formTitle: '',
        //-- funciones del date picker de fecha
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        menu2: false,
        inhabilitarFecha: false,
        inhabilitarHoraInicio: false,
        // Variables para la imagen
        previewImg: '',
        fileImageSave: '',
        archivoSubir: null,
        rutaServer: API_URL,
        inhabilitarButton: false,
        disableForm: false,
        filter: {},
        listNivel: [],
        listPeriodo: [],
        listGrado: [],
        listSeccion: [],
        listAlumno: [],
        alumnoDato: {},
        listTipoIncidencia: [],
        listIncidencia: [],
        listUsuarioPerfil: [],
        listUsuario: [],
        listPapeleta: [],

        //Descargar archivos del SPACE
        URL_SPACE: BUCKET_ORIGIN_SPACE,

        //Se almacenaran los dias habiles donde el estudiante tiene clases
        allowedDaysR: [],

        dialogIncidencia: false,
        formTitle2: "Seleccionar incidencias",
        search: "",

        //validaciones de formulario

        // PROPIEDADES PARA ALERTA

        disableModalFilters: false,
        disableModalNivel: false,
        disableModalGrado: false,
        disableModalSeccion: false,
        disableModalEstudiante: false,
        disableModalPeriodo: false,
        disableModalDocumentosIdentidad: false,


    }),

    mounted() {
        this.loadMain()
        this.$store.dispatch('getAlldiasEscolares').then(() => {
            this.allowedDaysR = this.diasEscolaresColegio;
        })

    },

    //computadas
    computed: {
        ...mapState(['diasEscolaresColegio']),

        ...mapGetters('login', ['componenteEvento']),

        computedDateFormatted2() {
            return this.formatDate(this.datos.fecha)
        },

        validationRules() {
            return validationRules
        }
    },
    watch: {

        estadoModal() {
            if (this.estadoModal) {
                console.log(this.estadoModal);
                this.loadMain()
            } else {
                this.limpiarForm()
            }
        }
    },
    methods: {

        ...mapActions('login', ['parametroComponente']),
        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        // Maxima Fecha Calendario fecha actual
        // getEndDate(){
        //     return  moment().format('YYYY-MM-DD')
        // }, COMENTADO PORQUE NO SE UTILIZA
        //  ------- input tipo fecha  --------
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        loadMain() {
            this.disableModalFilters = false;
            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_nivel: '',
                id_periodo: '',
                id_grado: '',
                id_seccion: '',
                id_alumno: '',
                id_tipo_incidencia: ''
            }
            this.limpiarForm()
            this.getTipoIncidencia()
            this.getUsuarioPerfil()
            this.getAnoLectivo(this.datoLogin.id_ano_lectivo)
            this.formTitle = "Crear registro de incidencia conductual"

            if (this.parametros.evento == 'edit') {
                this.disableModalFilters = true
                this.editItem(this.parametros.item)
                this.formTitle = "Editar registro de incidencia conductual"
                this.eventRegistroTipo(2)

            }

            if (this.parametros.evento == 'view') {
                this.disableModalFilters = true;
                this.disableForm = true;
                this.editItem(this.parametros.item)
                this.formTitle = "Ver registro de incidencia conductual"
                this.eventRegistroTipo(1)
            }

        },
        async editItem(item) {

            await this.eventTipoIncidencia(item.id_tipo_incidencia)
            this.eventPerfil(item.id_perfil)
            this.getAnoLectivo(item.id_ano_lectivo)
            this.datos = item
            this.datos.id_usuario = this.datoLogin.id
            this.datos.id_incidencia = item.id_incidencia
            this.datos.num_documento = item.num_documento.toString()

        },
        async getTipoIncidencia() {

            try {
                let response = await axios.get(`/administrativo/manualidades/incidencias/tipo/`)
                this.listTipoIncidencia = response.data
                console.log("fdsfdsfds", this.listTipoIncidencia)
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        async getUsuarioPerfil() {

            try {
                let response = await axios.get(`/sistema/usuario/getPerfil/colegio/${this.datoLogin.id_colegio}`)
                this.listUsuarioPerfil = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        async getAnoLectivo(id) {
            try {
                let params = { id_colegio: this.datos.id_colegio, id_ano_lectivo: id }
                let response = await axios.post(`/sistema/integral/getPeriodoActivo/`, { filter: params })
                if (response.data.length > 0) {
                    this.datos.ano_lectivo = response.data[0].nom_anolectivo
                    // this.datos.id_periodo  = response.data[0].id
                    // this.datos.periodo     = response.data[0].nombre_periodo 
                } else {
                    this.setEnviarMens({ tipo: "W", mensaje: `No existe año lectivo activo ni periodo`, tiempo: 6000 })
                }
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        async getPeriodo(id_colegio, id_ano_lectivo, id_nivel) {
            let params = { id_colegio, id_ano_lectivo, id_nivel }
            try {
                let response = await axios.post(`/sistema/integral/getPeriodo/`, { filter: params })
                this.listPeriodo = response.data
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }


        },
        async getNivel(id_ano_lectivo) {
            let params = { id_ano_lectivo, id_colegio: sessionStorage.id_colegio }
            try {

                let response = await axios.post(`/sistema/integral/getNivelAdm/`, { filter: params })
                this.listNivel = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        async getGrado(id_colegio, id_nivel) {
            let params = { id_colegio, id_nivel }
            try {

                let response = await axios.post(`/sistema/integral/getGradoAdm/`, { filter: params })
                this.listGrado = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        async getSeccion(id_colegio, id_grado) {
            let params = { id_colegio, id_grado }
            try {

                let response = await axios.post(`/sistema/integral/getSeccionAdm/`, { filter: params })
                this.listSeccion = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },

        async getAlumno(id_colegio, id_ano_lectivo, id_seccion) {
            let params = { id_colegio, id_ano_lectivo, id_seccion }

            try {
                let response = await axios.post(`/sistema/integral/getAlumnoSeccion/`, { filter: params })
                this.listAlumno = response.data.result
                if (response.data.length == 0)
                    this.setEnviarMens({ tipo: "W", mensaje: `No existen alumno para la sección seleccionada `, tiempo: null })
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },

        async eventSearch(num_documento) {

            try {
                if (num_documento == "" || num_documento == null) {
                    // this.setEnviarMens({tipo: 'W', mensaje: `Debe de Ingresar Un Documento `, tiempo:null})
                    this.datos.desc_nivel = ""
                    this.datos.desc_grado = ""
                    this.datos.nombre_seccion = ""
                    this.datos.alumno = ""
                } else {
                    // this.setEnviarMens({tipo: 'S', mensaje: `Buscando Documento ${num_documento}`, tiempo:null})
                    let params = {
                        id_colegio: this.datos.id_colegio, id_ano_lectivo: this.datos.id_ano_lectivo,
                        num_documento: this.datos.num_documento
                    }
                    let response = await axios.post(`/sistema/integral/getAlumnoSeccion/`, { filter: params })
                    let data = response.data //Tambien se actualizó el contrlador IntegralController.js
                    let result = data.result
                    let alumnoDato = result
                    this.alumnoDato = result


                    if (data.messageT !== "S") {
                        // Si falló termina no continues
                        this.datos.desc_nivel = ""
                        this.datos.desc_grado = ""
                        this.datos.nombre_seccion = ""
                        this.datos.alumno = ""
                        this.setEnviarMens({ tipo: data.messageT, mensaje: data.message, tiempo: null })
                        // Mostramos el mensaje y damos por terminado
                        return
                    }
                    // Si no pasa por el if, significa que sí se encontraron resultados
                    this.getPeriodo(this.datoLogin.id_colegio, this.datoLogin.id_ano_lectivo, result[0].id_nivel_seccion)
                    // this.datos.id_periodo= this.getPeriodo(this.datoLogin.id_colegio, this.datoLogin.id_ano_lectivo, result[0].id_nivel_seccion)

                    this.datos.id_alumno = alumnoDato[0].id_alumno
                    this.datos.desc_nivel = alumnoDato[0].desc_nivel
                    this.datos.desc_grado = alumnoDato[0].desc_grado
                    this.datos.nombre_seccion = alumnoDato[0].nombre_seccion
                    this.datos.alumno = `${alumnoDato[0].ape1_persona} ${alumnoDato[0].ape2_persona} ${alumnoDato[0].nombre_persona}`
                    this.setEnviarMens({ tipo: "S", mensaje: `Se encontraron coincidencias con: ${num_documento}`, tiempo: null })
                }
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        eventRegistroTipo(valor) {
            if (valor == 1) {
                if (this.datos.num_documento != "" || this.datos.num_documento != null) {
                    this.eventSearch(this.datos.num_documento)
                    this.getAlumno(this.datos.id_colegio, this.datos.id_ano_lectivo, this.datos.id_seccion)
                    this.eventNivel(this.filter.id_nivel)
                    this.getNivel(this.datoLogin.id_ano_lectivo)
                    this.eventGrado(this.filter.id_grado)
                    this.eventSeccion(this.filter.id_seccion)
                    this.getPeriodo()
                    // this.eventNivel(this.datoLogin.id_ano_lectivo)
                } else {
                    return;
                }
            }
            else {
                //Si valor==2
                this.getAlumno(this.datos.id_colegio, this.datos.id_ano_lectivo, this.datos.id_seccion)
                this.eventNivel(this.filter.id_nivel)
                this.getNivel(this.datoLogin.id_ano_lectivo)
                this.eventGrado(this.filter.id_grado)
                this.eventSeccion(this.filter.id_seccion)
                // this.eventAlumno(this.datos.id_alumno)
                // this.filter.id_nivel = ''
                // this.listGrado = []
                // this.filter.id_grado  = ''
                // this.listSeccion = []
                // this.filter.id_seccion = ''
                // this.listAlumno = []                
                // this.filter.id_alumno = '' 
                // this.listPeriodo = [];
            }
        },
        selectPeriodo(idperiodo) {
            this.datos.id_periodo = idperiodo;
        },
        eventNivel(id_nivel) {
            // this.setEnviarMens({tipo:"E", mensaje: `Nivel ${id_nivel}`, tiempo:null})
            this.listGrado = []
            this.filter.id_grado = ''
            this.listSeccion = []
            this.filter.id_seccion = ''
            this.listAlumno = []
            this.filter.id_alumno = ''
            this.getPeriodo(this.datoLogin.id_colegio, this.datoLogin.id_ano_lectivo, id_nivel)
            this.getGrado(this.datoLogin.id_colegio, id_nivel)

        },
        // eventPeriodo(id_periodo){
        //     // this.setEnviarMens({tipo:"E", mensaje: `Periodo ${id_periodo}`, tiempo:null})
        // }, COMENTADO PORQUE NO SE UTILIZA
        eventGrado(id_grado) {

            this.listSeccion = []
            this.filter.id_seccion = ''
            this.listAlumno = []
            this.filter.id_alumno = ''
            this.getSeccion(this.datoLogin.id_colegio, id_grado)

        },
        eventSeccion(id_seccion) {
            // this.setEnviarMens({tipo:"E", mensaje: `Seccion ${id}`, tiempo:null})
            this.listAlumno = []
            this.filter.id_alumno = ''
            this.getAlumno(this.datoLogin.id_colegio, this.datoLogin.id_ano_lectivo, id_seccion)
            // this.getIncidenciaCoductual(this.filter)
        },
        eventAlumno(id_alumno) {
            this.datos.id_alumno = id_alumno
            let alumno = this.listAlumno.find(alumno => alumno.id_alumno == id_alumno)
            this.datos.num_documento = alumno.numdoc_persona //Tambien hay que pasarle su documento porque el backend lo pide
        },
        async eventTipoIncidencia(id_tipo) {
            try {
                this.datos.id_incidencia = ""
                this.datos.nivel_incidencia = ""
                this.datos.incidencia = ""

                // listar Incidencia
                let params = { id_ano_lectivo: this.datos.id_ano_lectivo, id_tipo_incidencia: id_tipo }
                let response = await axios.post(`/administrativo/manualidades/incidencias/`, params)
                this.listIncidencia = response.data
                console.log("listIncidencia", this.listIncidencia)
                // listar Papeleta
                let response2 = await axios.post(`/administrativo/manualidades/papeletas/`, params)
                this.listPapeleta = response2.data
                console.log("papeletas", this.listPapeleta)
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        async findIncidencia(id) {
            if (this.datos.id_tipo_incidencia == "") {
                this.setEnviarMens({ tipo: 'W', mensaje: `Debe de seleccionar el tipo de incidencia`, tiempo: null })
                return false;
            }
            // this.seccionDocFilter = this.seccionDoc.filter(el=>el.id_grado == this.filtroProgDoc.id_grado)
            const incidencia = this.listIncidencia.filter(element => element.id == id)
            if (incidencia.length == 0) {
                this.datos.id_incidencia = ""
                this.datos.nivel_incidencia = ""
                this.datos.incidencia = ""
                this.setEnviarMens({ tipo: 'W', mensaje: `No se encontro ningun registro con este Nº (${id}) `, tiempo: null })
            } else {
                this.addIncidencia(incidencia[0])
            }
        },
        async eventIncidencia() {

            if (this.datos.id_tipo_incidencia == "") {
                this.setEnviarMens({ tipo: 'W', mensaje: `Debe de Seleccionar Tipo de Incidencia`, tiempo: null })
                return false;
            }
            this.dialogIncidencia = true
            // this.setEnviarMens({tipo: 'W', mensaje: `Listar Incidencia`, tiempo:null})
        },
        // Validar Meridiano

        //Descargar documento del SPACE
        async download(url) {
            //console.log(url)
            await this.$Files['downloadFetch']({ url });
        },

        async addIncidencia(item) {

            this.datos.id_incidencia = item.id
            this.datos.nivel_incidencia = item.nivel_incidencia
            this.datos.incidencia = item.descripcion
            // this.setEnviarMens({tipo: 'W', mensaje: `Seleccion de Incidencia Nº ${item.id}`, tiempo:null})
        },
        async eventPapeleta(id_papeleta) {
            let papeletaSelect = this.listPapeleta.find(element => element.id === id_papeleta);
            this.datos.puntaje = papeletaSelect.puntaje
        },
        async eventPerfil(id_perfil) {

            try {
                //this.setEnviarMens({tipo: 'W', mensaje: `LISTAR USUARIO POR PERFIL: ${id_perfil}`, tiempo:null})    
                let response = await axios.get(`sistema/usuario/getUsariosPerfil/colegio/${this.datoLogin.id_colegio}/perfil/${id_perfil}`)
                this.listUsuario = response.data
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;

            this.createImage(files[0]);
        },

        createImage(file) {
            let reader = new FileReader();

            reader.onload = (e) => {
                this.fileImageSave = e.target.result;  // Aquí se almacena el archivo para luego enviarlo al servidor
            };

            reader.readAsDataURL(file);
        },


        removeImg() {
            this.previewImg = ''
            this.fileImageSave = ''

            if (this.$refs.fileImageSave) {
                this.$refs.fileImageSave.value = '';
            }
        },


        resetValidation() {
            this.$refs.formDatos.resetValidation()
        },

        async submitForm() {
            const valid = await this.$refs.formDatos.validate();
            if (valid) {
                this.saveItem(this.URL_SPACE);
                this.removeImg();
            } else {
                console.log('El formulario no es válido. Por favor, complete los campos requeridos.');
                this.setEnviarMens({ tipo: "W", mensaje: `${'"Debe completar todos los campos y subir el archivo"'}`, tiempo: null })
            }
        },
        // Guardar Datos
        async saveItem(url) {


            this.datos.url = url
            if (this.parametros.evento == 'add' ||
                this.parametros.evento == 'edit') {

                try {

                    this.inhabilitarButton = true
                    let res
                    if (this.parametros.evento == 'add') {
                        res = await axios.post('/evaluacion/incidencia/', this.datos)
                        this.datos.id = res.data.data.id

                        if (this.archivoSubir) {
                            await this.saveImagen()
                        }

                    }
                    else if (this.parametros.evento == 'edit') {
                        res = await axios.put(`/evaluacion/incidencia/${this.parametros.item.id}`, this.datos)

                        if (this.archivoSubir) {
                            await this.saveImagen()
                        }
                    }
                    this.setEnviarMens({ tipo: `${res.data.messageT}`, mensaje: `${res.data.message}`, tiempo: 6000 })
                    this.datos = []
                    this.$emit('close')
                    this.inhabilitarButton = false

                }
                catch (error) {
                    this.inhabilitarButton = false
                    console.log(error)
                    this.setEnviarMens({ tipo: "E", mensaje: ` cathc ${error}`, tiempo: null })
                }

            }

        },


        async saveImagen() {

            let formData = new FormData();
            formData.append('subirArchivo', this.archivoSubir)
            formData.append('id_incidencia', this.datos.id)
            formData.append('colegio', this.datos.id_colegio)
            formData.append('ano_lectivo', this.datos.id_ano_lectivo)
            formData.append('id_usuario', this.datoLogin.id)

            try {

                let resp = ""
                if (this.parametros.evento == "add") {
                    resp = await axios.post('archivo/incidenciaConductual', formData)
                }
                else if (this.parametros.evento == "edit") {
                    resp = await axios.put('archivo/incidenciaConductual', formData)
                } else {
                    return false
                }

                return resp.data
            } catch (e) {
                console.log(e)
                this.setEnviarMens({ tipo: "E", mensaje: `Error en Subir Imagen`, tiempo: null })
                return false

            }

        },


        limpiarForm() {
            //    num_documento:77889966, num_documento2:55887745,                
            this.datos = {
                id_us: this.datoLogin.id,
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_periodo: "",
                id_tipo_incidencia: "",
                id_incidencia: "",
                id_papeleta: "",
                id_alumno: "",
                id_perfil: "",
                id_solicitante: "",
                registro_tipo: 1,
                ano_lectivo: "",
                periodo: "",
                desc_nivel: "",
                desc_grado: "",
                nombre_seccion: "",
                alumno: "",
                num_documento: "",
                fecha: "",
                hora: "",
                meridiano: "",
                nivel_incidencia: "",
                incidencia: "",
                puntaje: "",
                observacion: "",
                img_nombre: "",
                img_ruta: "",
                id_usuario: this.datoLogin.id //No sé si se trata del alumno o del usuario, pero de momento el del usuario ya se está usando al comienzo como id_us
            }


            this.previewImg = ''
            this.fileImageSave = ''
            this.disableForm = false
            this.resetValidation()

        },

        allowedDays: function (date) {
            return this.allowedDaysR.includes(date);
        },



    },
}
</script>